module.exports = __webpack_public_path__ + "static/media/Subtract.d69eb64d.svg";